import { StyleSheet, View } from 'react-native';

import { Skeleton, SkeletonTextBlock, tokens } from '@fhs/ui';

export function ChallengeHomeCardSkeleton() {
  return (
    <View style={styles.container}>
      <Skeleton style={styles.image} />
      <View style={styles.content}>
        <SkeletonTextBlock
          lines={2}
          style={styles.title}
          lineStyle={{ backgroundColor: tokens.colors.$blackOpacity10 }}
        />
        <Skeleton style={styles.button} />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    borderRadius: 8,
    borderWidth: 1,
    borderColor: tokens.colors.$blackOpacity10,
    backgroundColor: tokens.colors.$white,
    padding: 16,
    flexDirection: 'row',
  },
  content: {
    marginLeft: 12,
    flex: 1,
  },
  title: {
    flex: 1,
    width: '85%',
  },
  image: {
    width: 93,
    height: 93,
    backgroundColor: tokens.colors.$blackOpacity10,
    borderRadius: 4,
  },
  button: {
    marginTop: 12,
    height: 31,
    width: 112,
    alignSelf: 'flex-start',
    backgroundColor: tokens.colors.$blackOpacity10,
  },
});
